import { all, fork, put, select, takeLatest } from 'redux-saga/effects';
import { getWishlists, UPDATE_FILTER } from './index';
import { getCategoriesApi } from '../marketplace';

// === Watchers ===
function* loadRouteData() {
    const { wishlist } = yield select();
    // use the exported thunk to fetch initial data
    yield put(getWishlists(wishlist.wishlistFilter));
    yield put(getCategoriesApi({ page: 1, limit: 5 }));
}

function* handleFilterChange() {
    yield takeLatest(UPDATE_FILTER, function* () {
        const { wishlist } = yield select();
        yield put(getWishlists(wishlist.wishlistFilter));
    });
}

export function* loadWishlistPage() {
    yield all([
        fork(loadRouteData),
        fork(handleFilterChange),
    ]);
}

export default loadWishlistPage;
